interface TemplateDef {
  cols: string[];
  example: string[];
}

const TEMPLATES: Record<string, TemplateDef> = {
  workers: {
    cols: ['Full Name', 'Primary Role', 'Phone', 'Email', 'Postcode', 'Address', 'Status', 'Emergency Contact', 'Company Ref', 'Payroll Ref', 'Agency'],
    example: ['Jane Smith', 'Site Manager', '07700900000', 'jane@example.com', 'SW1A 1AA', '1 Example St', 'available', '', 'CLS-W100', 'PAY-100', 'ASHBROOKE'],
  },
  projects: {
    cols: ['Project ID', 'Name', 'Customer', 'Customer Ref', 'Value', 'Status', 'Manager', 'Manager Phone', 'Start Date', 'End Date', 'Address', 'Postcode'],
    example: ['CLS-P01', 'My Project', 'Customer Ltd', 'CR-1', '100000', 'live', 'John Smith', '07700000000', '2026-01-01', '2026-12-31', '1 Site Road', 'SW1A 1AA'],
  },
  customers: {
    cols: ['Company Name', 'Type', 'Sector', 'Address', 'Phone', 'Email'],
    example: ['ACME Ltd', 'Commercial', 'Construction', '1 Road London', '020 7000 0000', 'info@acme.com'],
  },
  contacts: {
    cols: ['Full Name', 'Company', 'Job Title', 'Department', 'Email', 'Phone'],
    example: ['John Smith', 'ACME Ltd', 'Director', 'Operations', 'j.smith@acme.com', '07700900000'],
  },
  suppliers: {
    cols: ['Company Name', 'Category', 'Compliance', 'Address', 'Phone', 'Email'],
    example: ['ABC Waste Ltd', 'Waste Management', 'approved', '1 Depot Road', '020 7000 0001', 'info@abc.com'],
  },
  training: {
    cols: ['Worker Name', 'Cert Type', 'Expiry Date', 'Status', 'Doc Reference'],
    example: ['Jane Smith', 'SMSTS', '2027-01-01', 'valid', 'SMSTS-001.pdf'],
  },
  deploylog: {
    cols: ['Worker Name', 'Project ID', 'Start Date', 'Start Time', 'Duration', 'Supervisor', 'Status', 'Notes'],
    example: ['Jane Smith', 'CLS-001', '2026-04-14', '07:30', '1 day', 'Site Supervisor', 'active', ''],
  },
  vacancies: {
    cols: ['Role', 'Project ID', 'Start Date', 'Duration', 'Notes'],
    example: ['Electrician', 'CLS-001', '2026-05-01', '1 week', ''],
  },
};

function csvEscape(v: string): string {
  if (/[",\n]/.test(v)) return `"${v.replace(/"/g, '""')}"`;
  return v;
}

export function downloadImportTemplate(entity: string): boolean {
  const t = TEMPLATES[entity];
  if (!t) return false;
  const csv = t.cols.join(',') + '\n' + t.example.map(csvEscape).join(',') + '\n';
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `CLS_${entity}_template.csv`;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 100);
  return true;
}

export function listImportTemplateEntities(): string[] {
  return Object.keys(TEMPLATES);
}
